define.alias("ember-assign-helper/helpers/assign", "settings/helpers/assign");